export default "__VITE_ASSET__cc1244ba__"